<template>
    <div class="variable" :class="`variable--${instance.type} variant--${instance.variant}`" :data-field="instance.field">
        <!--{{instance}}-->
        <div :class="`variable__response--${instance.line_layout}`" class="variable__response type--content-styles type--content-margins type--content-links v--10">
            <div v-if="instance.header" class="variable__response__header">
                <div :class="instance.header_type" v-text="instance.header"></div>
            </div>
            <div class="variable__response__text">
                <span v-if="instance.type === 'default'" class="type--p" v-html="formatAs(answer)"></span>
                <ul v-if="instance.type === 'list'" :class="`list--${instance.list_style}`">
                    <li v-for="item in answer" :key="item.id">
                        {{ formatAs(item) }}
                    </li>
                </ul>
                <div v-if="instance.type === 'decisions'" class="decisions__list r v--25">
                    <div v-for="(f, index) in siloData.user.modules[instance.impulsive_key]" :key="index" class="decisions__list__item r v--15" :data-key="index">
                        <div class="decisions__list__item__impulsive r v--5">
                            <span><strong>Impulsive decision:</strong></span>
                            <span>{{ f }}</span>
                        </div>
                        <div class="decisions__list__item__thoughtful r v--5">
                            <span><strong>Thoughtful decision:</strong></span>
                            <span>{{ siloData.user.modules[instance.thoughtful_key][index] }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="instance.type === 'goals'" class="goals__list r type--content-margins">
                    <p><strong> Your goal is to {{ siloData.user.modules['meta_goals_goal_l'] }}</strong></p>
                    <p v-for="response in siloData.user.modules['meta_goals_responses']">
                        <strong>{{ response.question_short }}:</strong> <span>{{ response.answer }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        components: {
        },
        data() {
            return {
            }
        },
        computed: {
            answer() {
                let answer = this.siloData.user.modules[this.instance.field];

                if (answer === null) {return "";}

                let answer_array = [];

                // If this is an array, pass the answer to the answer array
                if (Array.isArray(answer)) {
                    answer_array = answer;
                    return answer_array;
                // Otherwise, set the first index of the answer array to the answer
                } else {
                    answer_array[0] = answer;
                    return answer_array;
                }
            },
        },
        props: {
            siloData: Object,
            instance: Object,
        },
        watch: {

        },
        methods: {
            formatAs(string) {
                let new_string = "";
                let returned = "";

                // If we're passing an array, just grab the first item
                if (Array.isArray(string)) {
                    new_string = string[0];
                } else {
                    new_string = string;
                }

                returned = new_string;
                
                // ! This is messed up
                if (this.instance.format === "date") {
                    returned = moment.utc(new_string).format('M/D/YYYY');
                }

                // Has to be an array
                if (this.instance.format === "count") {
                    returned = string.length;
                }

                if (this.instance.format === "likert") {
                    let n = parseInt(string);
                    let interpretation = "not ";
                    if (n === 1 || n === 2 || n === 3) {
                        interpretation = "a little ";
                    }
                    if (n === 4 || n === 5 || n === 6) {
                        interpretation = "";
                    }
                    if (n === 7 || n === 8 || n === 9) {
                        interpretation = "very ";
                    }
                    if (n === 10) {
                        interpretation = "extremely ";
                    }
                    returned = `${new_string} (${interpretation}${this.instance.tag})`;
                }

                return returned;
            }
        }
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.variant--large {
    .variable__response__text * {
        font-size: rem(18px);
        line-height: lh(18px, 24px);
        letter-spacing: 0.22px;
    }
}
.list--double {
    margin-left: rem(40px) !important;
    list-style-type: circle !important;
}
// Format the lines as a single line of text
.variable__response--single {
    > * {
        display: inline !important;
        > * {
            display: inline !important;
        }
    }
    .variable__response__text {
        > * {
            font-size: rem(17px);
            line-height: lh(17px, 22px);
            font-weight: $weight_medium;
            letter-spacing: 0.21px;
        }
    }
}
.variable__response__header {
    .type--p {
        font-weight: $weight_bold !important;
    }
}
.decisions__list {
    margin-top: rem(25px);
}
</style>